// Gebeurtenissenlijst (activity_log): de tijdlijn die de gebruiker ziet. Geen
// bewijs: deze tabel is bewerkbaar. Het onwrikbare spoor wordt audit_log, met
// een eigen schrijver in de database (technisch implementatieplan, stap D).
import { getClient } from './supabase.js';
import { state } from '../state.js';
import { round2 } from '../lib/money.js';

// Every entry records who caused it. Without an actor a financial mutation
// cannot be traced back to a person, which is the whole point of the log.
export async function logActivity(teamId,teamName,actionType,description,oldValue='',newValue='',amountDelta=null) {
  const row = {
    event_id:state.currentEventId,team_id:teamId||null,team_name:teamName||'',
    action_type:actionType,description,old_value:String(oldValue||''),new_value:String(newValue||''),
    actor_email:state.currentUserEmail||'system'
  };
  if (amountDelta !== null && amountDelta !== undefined) row.amount_delta = round2(amountDelta);
  const { error } = await getClient().from('activity_log').insert([row]);
  // The migration may not have been run yet. Rather than losing the entry,
  // retry without the new columns so the log keeps working either way.
  if (error && /actor_email|amount_delta/.test(error.message||'')) {
    delete row.actor_email; delete row.amount_delta;
    await getClient().from('activity_log').insert([row]);
  }
}
